<div class="ticket-duration-body text-center">
  <div>{{ productTimeSpan.timeSpan + ' '}}
    <span>{{ productTimeSpan.label | translate }}</span>
  </div>
</div>
<!-- <div class="available">{{ productTimeSpan.available }}</div> -->
<div class="ticket-duration-price" style="display: block;">{{ productTimeSpan.footer | translate }}</div>
